/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import ClusterListPage from '@modules/ccm-admin-components/ClusterListPage'
import RoutablePage from '@modules/routing/RoutablePage'
import AdminCCMClusterManagementPage from '@modules/ccm-admin-components/AdminCCMClusterManagementPage'

import { isCCMFeatureActivated } from './feature'

import type { RouteObject } from 'react-router-dom'

export default function getCCMServiceSelectionRoutes(): RouteObject[] {
  if (!isCCMFeatureActivated()) {
    return []
  }

  return [
    {
      path: 'connected-clusters',
      children: [
        {
          index: true,
          element: (
            <RoutablePage title='Connected Clusters'>
              <ClusterListPage />
            </RoutablePage>
          ),
        },
        {
          path: ':clusterId',
          element: (
            <RoutablePage title='Connected cluster'>
              <AdminCCMClusterManagementPage />
            </RoutablePage>
          ),
        },
      ],
    },
  ]
}
